// extracted by mini-css-extract-plugin
export default {"sectionText":"RichText_sectionText__C2fRq","sectionHeading":"RichText_sectionHeading__E0H27 p","text":"RichText_text__o1SHR","longWord":"RichText_longWord__9GCt9"};